import { api } from '@creditsights/api-ui-web';

export interface Document {
  title: string;
  id: string;
  publishedDate: string;
  url: string;
}

export interface Question {
  query_seq_id: number;
  query: string;
  cb_response: string;
  source_documents?: Document[];
  query_dtm: string;
  user_feedback_type?: string;
  usr_thumbs_up?: boolean;
  usr_comments?: string;
  ui_show_feedback_form?: boolean;
}

export interface Session {
  session_dtm: string;
  session_id: string;
  session_history: Question[];
}

export const getSessions = async (): Promise<Session[]> => {
  const { data } = await api.get('/cs-genie/v1/history/all', { timeout: 60000 });
  return data;
};
